export const COLORS = {
	LIGHT_BLUE: '#54b7ff',
	LIGHT_BLUE_HOVER: '#7ac7ff', // '#469bd7',
	BLUE: '#137ade',
	DARK_BLUE: '#061e38',
	LIGHT_GREEN: '#aed79b',
	GREEN: '#20c997',
	GREEN_HOVER: '#199477',
	WHITE: '#ffffff',
	BLACK: '#000000',
	DARK_GREY: '#333333',
	GREY: '#666666',
	LIGHT_GREY: '#dddddd',
	RED: '#dc3545'
} as const;